export default __webpack_public_path__ + "static/media/lorelaïm.68402ecc.webp";